import React from 'react';
import { Skeleton } from './ui/skeleton';

export const SectionSkeleton = () => (
  <div className="space-y-6" data-testid="section-skeleton">
    <Skeleton className="h-8 w-56" />
    <div className="grid gap-4 grid-cols-2 lg:grid-cols-4">
      {[0, 1, 2, 3].map((i) => <Skeleton key={i} className="h-24 rounded-xl" />)}
    </div>
    <Skeleton className="h-64 rounded-xl" />
  </div>
);

export const PageSkeleton = () => (
  <div className="min-h-screen bg-slate-50 p-6 lg:p-10" data-testid="page-skeleton">
    <div className="max-w-5xl mx-auto"><SectionSkeleton /></div>
  </div>
);
